import test from './components/test';
import header from './components/header';
import scrollTop from './components/scrollTop';

document.addEventListener(
  'DOMContentLoaded',
  () => {
    test();
    header();
    scrollTop();
  },
  false
);
